<template>
  <div class="product">
    <slot />
    <div v-if="isRateActive(rate.key) && this.$store.state.configuredRate" class="pt-10 px-4 pb-3">
      <div class="flex flex-col items-center justify-center max-w-md mx-auto px-8">
        <RouterLink to="/products" class="relative no-underline w-full sm:w-1/2 mb-3">
          <DrButton class="btn-sm btn-outline btn-blue w-full" @click.prevent="removeChanges">
            Cancel changes
          </DrButton>
        </RouterLink>
        <DrButton v-if="isRateRemovable" class="no-underline btn-sm btn-red btn-outline w-full sm:w-1/2" @click.prevent="handleRemoveRate">
          Remove this cover
        </DrButton>
      </div>
    </div>
  </div>
</template>

<script>
import rateMixin from '@/mixins/rate'

export default {
  mixins: [rateMixin],
  props: {
    rate: {
      type: Object,
      required: true,
    },
  },
  mounted () {
    const rate = this.getRate(this.rate.key)

    this.$store.commit('updateConfiguredRate', rate)
  },
  destroyed () {
    this.$store.commit('updateConfiguredRate', null)
    this.$store.commit('updateEstimate', null)
    this.$store.commit('updateEstimateLoading', false)
  },
  methods: {
    async handleRemoveRate () {
      await this.removeRate(this.rate.key)

      await this.$store.dispatch('updateQuote', this.$store.getters.getEstimate)

      this.$router.push('/products')
    },
    removeChanges () {
      this.$router.push('/products')
    },
  },
}
</script>
